import axios from "axios";
import { ERRORS } from "../helpers/constants";

const VITE_API_ENDPOINT = "https://chalobharatdekhen.com/tapi"
// const VITE_API_ENDPOINT = "http://localhost:3002/api/v1"
// const VITE_API_ENDPOINT = "https://192.168.1.8:3002/api/v1"

export function APIFY(path) {
  return VITE_API_ENDPOINT.concat(path);
}

export async function HTTP_CLIENT(url, method, data, params = {}, header = "json") {
  const handleJWTExpirationError = (err) => {
    if (err?.response?.data?.error === ERRORS.TOKEN_EXPIRED) {
      document.location.href = "/";
    }
  };

  try {
    const accessToken = localStorage.getItem("access_token");

    const headers = {
      "Content-Type": header !== "json" ? "multipart/form-data" : "application/json",
    };

    if (accessToken) {
      headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const query = new URLSearchParams(params).toString();
    if (query) {
      url = url.includes("?") ? `${url}&${query}` : `${url}?${query}`;
    }

    const response = await axios.request({
      method,
      url,
      headers,
      data,
    });

    return response.data;
  } catch (error) {
    handleJWTExpirationError(error);
    throw error;
  }
}

export async function registerUser(email, password, name, phone) {
  try {
    const params = {
      name,
      email,
      password,
      phone,
      role: ["user"],
    };

    const data = await HTTP_CLIENT(APIFY("/users/register"), "POST", params);

    // ✅ return response directly instead of local var
    return data?.data ?? null;
  } catch (error) {
    console.error("Register error:", error.message);
    return null;
  }
}
